/* global axios */
import ApiClient from './ApiClient';
import { requestConfig, resourcePath } from './lais/httpHelpers';

class PrivacyOperationsAPI extends ApiClient {
  constructor() {
    super('privacy', { accountScoped: true });
  }

  operationalStatus(params = {}) {
    return axios.get(
      resourcePath(this.url, 'operational_status'),
      requestConfig(params)
    );
  }

  createErasureDryRun({ contactId, reason } = {}) {
    return axios.post(
      resourcePath(this.url, 'erasure_requests'),
      {
        contact_id: contactId,
        mode: 'dry_run',
        reason,
      },
      requestConfig()
    );
  }
}

export default new PrivacyOperationsAPI();
